import React, { useEffect, useState } from 'react';
import Header from './components/Header/Header';
import BettingLayout from './components/betttingCardPannel/BettingCard';
import Footer from './components/footer/footer';
import VIPAdsPopup from './components/popup/VIPAdsPopup';
import axios from 'axios';

function App() {
  const [showPopup, setShowPopup] = useState(true);
  const [cards, setCards] = useState([]);
  const [vipCards, setVipCards] = useState([]);

  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || "https://bonushub.osys.sr/api/";

  const apiVipAdds = "vipadds";
  const apiAdds = "adds";

  const targetUrlVipAdds = `${apiBaseUrl}${apiVipAdds}`;
  const targetUrlAdds = `${apiBaseUrl}${apiAdds}`;
 
  useEffect(() => {
    const fetchData = async () => {
      try {
        // const response = await axios.get(`${proxyUrl}${targetUrl}`);
        const responseVipAdds = await axios.get(targetUrlVipAdds);
        const responseAdds = await axios.get(targetUrlAdds);
       
        setCards(responseAdds.data?.Value || []);
        setVipCards(responseVipAdds.data?.Value || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);
  return (
    <>
      <Header />
      <BettingLayout cards={cards} />
      <Footer />

      {showPopup && <VIPAdsPopup cards={vipCards} onClose={() => setShowPopup(false)} />}
    </>
  );
}

export default App;
